import { Directive } from '@angular/core'

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'textarea',
  standalone: true,
})
export class NativeTextareaDirective {}
